import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { TableCell, TableRow } from "@/components/ui/table";
import { DollarSign } from "lucide-react";

interface MediaOfferingRowProps {
  media_name: string;
  media_descr: string | null;
  price: number;
  is_available: boolean;
  onPriceChange: (price: string) => void;
  onAvailabilityChange: (checked: boolean) => void;
}

export function MediaOfferingRow({
  media_name,
  media_descr,
  price,
  is_available,
  onPriceChange,
  onAvailabilityChange,
}: MediaOfferingRowProps) {
  return (
    <TableRow>
      <TableCell className="font-medium">
        {media_name}
      </TableCell>
      <TableCell>
        {media_descr || "No description"}
      </TableCell>
      <TableCell>
        <div className="flex items-center space-x-2">
          <DollarSign className="h-4 w-4 text-muted-foreground" />
          <Input
            type="number"
            value={price}
            onChange={(e) => onPriceChange(e.target.value)}
            className="w-24"
            min={0}
            step={0.01}
          />
        </div>
      </TableCell>
      <TableCell>
        <Switch
          checked={is_available}
          onCheckedChange={onAvailabilityChange}
        />
      </TableCell>
    </TableRow>
  );
}